<div class="grid grid-cols-7 gap-2 w-full px-6" style="margin-bottom: 20vh">
    <div class="col-span-5 mt-6 w-full">
        <div class="bg-card shadow rounded-2xl">
            <div class="text-center p-4 header rounded-t-2xl grid grid-cols-12">
                <button class="col-span-1 text-left" (click)="openInfo()" class="mx-2">
                    <mat-icon svgIcon="heroicons_solid:information-circle" matPrefix class="text-white"></mat-icon>
                </button>

                <h1 class="col-span-11 text-center">
                    <b> CRITICAL DEVICE FUNCTION TEST (CDFT) FORM </b>
                </h1>
            </div>
            <mat-accordion class="w-full">
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title> HEADER </mat-panel-title>
                    </mat-expansion-panel-header>

                    <header [isViewOnly]="true"></header>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            XMAS TREE & WELLHEAD VALVE TEST REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <wellhead-valve [isViewOnly]="true"></wellhead-valve>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SSSV / DOWNHOLE BARRIER TEST REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <sssv-barrier [isViewOnly]="true"></sssv-barrier>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            ANNULUS PRESSURE MONITORING REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <app-annulus-pressure-table [isViewOnly]="true"></app-annulus-pressure-table>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            CONTROL LINE TEST REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <control-line [isViewOnly]="true"></control-line>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            WELLHEAD SUBSIDENCE MONITORING REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <wellhead-subsidence [isViewOnly]="true"></wellhead-subsidence>
                </mat-expansion-panel>
            </mat-accordion>

            <div class="text-center p-4 header rounded-b-2xl">
                <h1>
                    <b>
                        <span> SAFETY FIRST! </span><br />
                        Please comply with all safety WARNINGS prior to
                        performing any task.
                    </b>
                </h1>
            </div>
        </div>
    </div>
    <div class="col-span-2 rounded-b-2xl mt-6 sticky w-full">
        <div class="bg-card shadow rounded-2xl  top-2">
            <app-cdft-detail [isViewOnly]="true"></app-cdft-detail>
        </div>

        <div *ngIf="showWfamStatus" class="bg-card shadow rounded-2xl mt-4">
            <app-wfam-detail> </app-wfam-detail>
        </div>
    </div>
</div>

<div class="fixed bottom-0 right-0 p-4 bg-card w-full">
    <div class="flex justify-end">
        <button class="btn btn-primary mx-1" (click)="location.back()">
            Back
        </button>
        <button *ngIf="(!isReadyOrApproved && !isloading) && hasCdftEditRoles()"
            class="btn btn-outline btn-default mx-1" (click)="edit()">
            Edit
        </button>
        <button *ngIf="approverCdftRoles()" class="btn btn-outline btn-info mx-1" (click)="updateStatus()"
            [disabled]="isReady">
            Status
        </button>
    </div>
</div>